import '../../css/share/common.scss';
import './layout/_header';
import { lazyload } from "./components/_lazyload.js";

$(function() {

    $('a[href$="#"]').click(function(e) {
        e.preventDefault();
    });

    //--------------------- imagesLoaded ---------------------//
    function removeLoading() {
        $(".loading").fadeOut(function() {
            $(this).remove();
        });
    }

    imagesLoaded("html, body", function() {
        removeLoading();
        lazyload();
    });
});